<template>
  <div id="detalhes-da-solicitacao" class="dados-da-solicitacao">
    <div class="container container_com-fundo container_com-margem">
      <loading :ativo="loading.visivel" :mensagem="loading.mensagem" />
      <div class="logos print has-text-centered">
        <img src="../../../assets/imagens/logo-relatorio-retrato.jpg" />
      </div>
      <h2 class="print title-print">Detalhes da solicitação</h2>
      <div class="grade__linha grade__linha_alinhar-vertical-ao-topo">
        <div class="grade__coluna grade__coluna_3">
          <div class="titulo titulo_gigante u-margem-inferior-pequena">
            Subsídio da AGEHAB
          </div>
          <div class="titulo titulo_medio u-margem-inferior-pequena">
            {{ subsidioDaAgehab }}
          </div>
          <div
            :class="[
              'tags',
              classeCssDaCor(
                'tags',
                obterCorDoStatusDaSolicitacao(statusDaSolicitacao)
              ),
            ]"
          >
            {{ status }}
          </div>
        </div>

        <div class="grade__coluna grade__coluna_9">
          <div
            class="u-nao-imprimir grade__linha grade__linha_alinhar-horizontal-direita"
          >
            <button
              v-if="acoesPermidasDaSolicitacao.PermiteAprovacao"
              type="button"
              @click="abrirModalDeAprovacao"
              class="no-print botao botao_cor-terciaria botao_com-icone-para-esquerda botao_contorno botao_sem-preenchimento botao_medio u-margem-direita-media"
            >
              Aprovar
            </button>
            <button
              v-if="acoesPermidasDaSolicitacao.PermiteAprovacaoDeCertificado"
              type="button"
              @click="abrirModalDeAprovacaoDeCertificado"
              class="no-print botao botao_cor-terciaria botao_com-icone-para-esquerda botao_contorno botao_sem-preenchimento botao_medio u-margem-direita-media"
            >
              Aprovar
            </button>
            <button
              v-if="acoesPermidasDaSolicitacao.PermiteCancelamento"
              type="button"
              @click="abrirModalDeCancelamento"
              class="no-print botao botao_cor-terciaria botao_com-icone-para-esquerda botao_contorno botao_sem-preenchimento botao_medio u-margem-inferior-grande"
            >
              Indeferir
            </button>
          </div>

          <div
            class="no-print grade__linha grade__linha_alinhar-horizontal-direita"
          >
            <div class="dropdown dropdown_direita">
              <button
                class="botao botao_cinza botao_com-icone-para-direita botao_sem-preenchimento botao_medio"
                aria-haspopup="true"
              >
                Ações <i class="far fa-chevron-down"></i>
              </button>
              <ul ul class="dropdown__lista" aria-label="Submenu">
                <li class="dropdown__item">
                  <button
                    v-if="acoesPermidasDaSolicitacao.PermiteEdicao"
                    type="button"
                    @click="redirecionarParaEdicao"
                    class="no-print botao botao_cinza botao_com-icone-para-esquerda botao_sem-preenchimento botao_medio largura-maxima u-texto-alinhado-a-esquerda"
                  >
                    <i class="fa fa-pencil" aria-hidden="true"></i> Editar
                  </button>
                </li>
                <li class="dropdown__item">
                  <button
                    type="button"
                    onclick="window.print()"
                    class="no-print botao botao_cinza botao_com-icone-para-esquerda botao_sem-preenchimento botao_medio largura-maxima u-texto-alinhado-a-esquerda"
                  >
                    <i class="fa fa-print" aria-hidden="true"></i> Imprimir
                  </button>
                </li>
                <li class="dropdown__item">
                  <button
                    v-if="
                      acoesPermidasDaSolicitacao.PermiteEntregaDoCertificado
                    "
                    type="button"
                    @click="abrirModalDeEntregaDoCertificado()"
                    class="no-print botao botao_cinza botao_com-icone-para-esquerda botao_sem-preenchimento botao_medio largura-maxima u-texto-alinhado-a-esquerda"
                  >
                    <i class="far fa-person-carry" aria-hidden="true"></i>
                    Informar entrega
                  </button>
                </li>
                <li class="dropdown__item">
                  <button
                    v-if="
                      acoesPermidasDaSolicitacao.PermiteDownloadDaDeclaracao
                    "
                    type="button"
                    @click="baixarDeclaracao()"
                    class="no-print botao botao_cinza botao_com-icone-para-esquerda botao_sem-preenchimento botao_medio largura-maxima u-texto-alinhado-a-esquerda"
                  >
                    <i class="fa fa-download" aria-hidden="true"></i> Baixar
                    declaração
                  </button>
                </li>
                <li class="dropdown__item">
                  <button
                    v-if="
                      acoesPermidasDaSolicitacao.PermiteDownloadDoCertificado
                    "
                    type="button"
                    @click="baixarCertificado()"
                    class="no-print botao botao_cinza botao_com-icone-para-esquerda botao_sem-preenchimento botao_medio largura-maxima u-texto-alinhado-a-esquerda"
                  >
                    <i class="fa fa-download" aria-hidden="true"></i> Baixar
                    certificado
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="borda">
        <h2 class="titulo titulo_pequeno u-margem-inferior-media title is-5">
          Dados do Proponente
        </h2>
        <div v-for="(proponente, index) in proponentes">
          <span class="titulo titulo_pequeno">
            {{ index + 1 }}º Proponente
          </span>
          <div class="field is-horizontal">
            <div class="linha">
              <div class="field coluna">
                <span class="label">
                  <strong>Nome:</strong>
                </span>
                <span>{{ proponente.Nome }}</span>
              </div>
              <div class="field coluna">
                <span class="label">
                  <strong>CPF:</strong>
                </span>
                <span>{{ proponente.Cpf }}</span>
              </div>
              <div class="field coluna">
                <span class="label">
                  <strong>Telefone: </strong>
                </span>
                <span>{{ proponente.Telefone || "NÃO INFORMADO" }}</span>
              </div>
            </div>
          </div>
          <div v-if="proponente.Conjuge">
            <span class="titulo titulo_pequeno">
              {{ index + 1 }}º Cônjuge
            </span>
            <div class="field is-horizontal">
              <div class="linha">
                <div class="field coluna">
                  <span class="label">
                    <strong>Nome:</strong>
                  </span>
                  <span>{{ proponente.Conjuge.Nome }}</span>
                </div>
                <div class="field coluna">
                  <span class="label">
                    <strong>CPF:</strong>
                  </span>
                  <span>{{ proponente.Conjuge.Cpf }}</span>
                </div>
                <div class="field coluna">
                  <span class="label">
                    <strong>Telefone: </strong>
                  </span>
                  <span>{{
                    proponente.Conjuge.Telefone || "NÃO INFORMADO"
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="field-body field-body-linha">
          <div class="field">
            <span class="label">
              <strong>Renda familiar comprovada:</strong>
            </span>
            <span
              ><strong>{{ rendaTotalComprovada }}</strong></span
            >
          </div>
        </div>
      </div>

      <div class="borda">
        <h2 class="titulo titulo_pequeno u-margem-inferior-media title is-5">
          Dados do Imóvel
        </h2>
        <div class="field is-horizontal">
          <div class="linha">
            <div class="field coluna">
              <span class="label">
                <strong>Construtora:</strong>
              </span>
              <span>{{ construtora.Nome }}</span>
            </div>
            <div class="field coluna">
              <span class="label">
                <strong>CNPJ:</strong>
              </span>
              <span>{{ construtora.Cnpj }}</span>
            </div>
          </div>
          <div class="linha">
            <div class="field coluna">
              <span class="label">
                <strong>APF:</strong>
              </span>
              <span>{{ imovel.Apf }}</span>
            </div>
            <div class="field coluna">
              <span class="label">
                <strong>Conta vinculada:</strong>
              </span>
              <span>{{ construtora.Conta }}</span>
            </div>
          </div>
          <div class="linha">
            <div class="field coluna">
              <span class="label">
                <strong>Cidade:</strong>
              </span>
              <span>{{ cidade.Nome + " - " + cidade.EstadoNome }}</span>
            </div>
            <div class="field coluna">
              <span class="label">
                <strong>Endereço:</strong>
              </span>
              <span
                >{{ endereco.TipoDeLogradouro.Nome }} {{ endereco.Logradouro }},
                nº {{ endereco.NumeroDoImovel }}</span
              >
            </div>
          </div>
          <div class="linha">
            <div class="field coluna">
              <span class="label">
                <strong>CEP:</strong>
              </span>
              <span>{{ endereco.Cep }}</span>
            </div>
            <div class="field coluna">
              <span class="label">
                <strong>Bairro/Complemento:</strong>
              </span>
              <span>{{ endereco.Bairro }}, {{ endereco.Complemento }}</span>
            </div>
          </div>
          <div class="linha">
            <div class="field coluna">
              <span class="label">
                <strong>Empreendimento:</strong>
              </span>
              <span>{{ empreendimento.Nome }}</span>
            </div>
            <div class="field coluna">
              <span class="label">
                <strong>Tipo de empreendimento:</strong>
              </span>
              <span>{{ empreendimento.TipoDeEmpreendimento }}</span>
            </div>
          </div>

          <div class="linha">
            <div class="field coluna">
              <span class="label">
                <strong>Valor de compra e venda:</strong>
              </span>
              <span>{{ valorDaCompraEVenda }}</span>
            </div>
            <div class="field coluna">
              <span class="label">
                <strong>Valor do financiamento:</strong>
              </span>
              <span>{{ valorDoFinanciamentoAprovado }}</span>
            </div>
          </div>

          <div class="linha">
            <div class="field coluna">
              <span class="label">
                <strong>Subsídio do Governo Federal:</strong>
              </span>
              <span>{{ subsidioDoGovernoFederal }}</span>
            </div>
            <div class="field coluna">
              <span class="label">
                <strong>Subsídio da AGEHAB:</strong>
              </span>
              <span>{{ subsidioDaAgehab }}</span>
            </div>
          </div>

          <div class="linha">
            <div class="field coluna">
              <span class="label">
                <strong>Desconto da construtora:</strong>
              </span>
              <span>{{ descontoDaConstrutora }}</span>
            </div>
            <div class="field coluna">
              <span class="label">
                <strong>Participação do proponente:</strong>
              </span>
              <span>{{ participacaoDoSolicitante }}</span>
            </div>
          </div>

          <div class="linha">
            <div class="field coluna">
              <span class="label">
                <strong>Matrícula:</strong>
              </span>
              <span>{{ imovel.Matricula }}</span>
            </div>
          </div>
        </div>
      </div>

      <h2 class="titulo titulo_medio u-margem-superior-media">
        Histórico da solicitação
      </h2>
      <div class="historico-situacao timeline-body">
        <div
          class="timeline-container"
          v-for="historicoItem of historicoDoStatus"
        >
          <div class="timeline-item">
            <span class="marcacao">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
            </span>
            <span class="informacoes">
              <span
                v-if="historicoItem.DescricaoDoStatus !== 'NULO'"
                :class="[
                  'u-margem-inferior-pequena tags',
                  classeCssDaCor(
                    'tags',
                    obterCorDoStatusDaSolicitacao(historicoItem.Status)
                  ),
                ]"
              >
                {{ historicoItem.DescricaoDoStatus }}
              </span>
              <span class="data-situacao u-margem-inferior-mini">
                <strong>Data:</strong>
                {{ historicoItem.DataDoEvento }}
              </span>
              <span
                class="data-situacao u-margem-inferior-mini"
                v-if="historicoItem.Usuario.Nome"
              >
                <strong>Responsável:</strong>
                {{ historicoItem.Usuario.Nome }}
              </span>
              <span
                class="data-situacao u-margem-inferior-mini"
                v-if="permiteExibirJustificativaNoHistorico(historicoItem)"
              >
                <strong>Justificativa:</strong>
                {{ historicoItem.Observacao }}
              </span>
            </span>
          </div>
        </div>
      </div>
      <modal v-if="modalDeAprovacaoEstaVisivel" @close="fecharModalDeAprovacao">
        <form @submit.prevent="aprovar" class="formulario">
          <h3 class="titulo titulo_medio u-margem-inferior-media">
            Aprovar solicitação
          </h3>
          <hr class="u-margem-inferior-grande" />
          <div>
            <p class="mensagem-confirmacao u-margem-inferior-grande">
              <strong>Tem certeza que deseja aprovar essa solicitação?</strong>
            </p>
          </div>
          <div
            class="grade__linha_alinhar-horizontal-direita formulario-button"
          >
            <button
              type="button"
              @click="fecharModalDeAprovacao"
              class="botao botao_cinza botao_medio u-margem-direita-pequena"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="botao botao_cor-terciaria botao_medio"
              :class="{ 'is-loading': loading.visivel }"
            >
              Confirmar
            </button>
          </div>
        </form>
      </modal>
      <modal
        v-if="modalDeEntregaDoCertificadoEstaVisivel"
        @close="fecharModalDeEntregaDoCertificado"
      >
        <form @submit.prevent="entregarCertificado" class="formulario">
          <h3 class="titulo titulo_medio u-margem-inferior-media">
            Informar data de entrega do certificado
          </h3>
          <hr class="u-margem-inferior-grande" />
          <div class="u-margem-inferior-grande">
            <div class="grade__coluna_5">
              <p>
                Nome: {{ proponentes[0].Nome }} <br />
                CPF: {{ proponentes[0].Cpf }}
              </p>
            </div>
            <div class="grade__coluna_5 u-margem-superior-media">
              <label
                for="dataDeEntregaDoCertificado"
                class="label u-margem-bottom-mini"
                >Data da entrega</label
              >
              <input
                v-model="dataDeEntregaDoCertificado"
                id="dataDeEntregaDoCertificado-"
                name="dataDeEntregaDoCertificado"
                class="formulario__input u-margem-superior-pequena"
                type="date"
                required
              />
            </div>
          </div>
          <div
            class="u-margem-superior-grande grade__linha_alinhar-horizontal-direita formulario-button"
          >
            <button
              type="button"
              @click="fecharModalDeEntregaDoCertificado"
              class="botao botao_cinza botao_medio u-margem-direita-pequena"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="botao botao_cor-terciaria botao_medio"
              :class="{ 'is-loading': loading.visivel }"
              :disabled="!dataDeEntregaDoCertificado"
            >
              Salvar
            </button>
          </div>
        </form>
      </modal>
      <modal
        v-if="modalDeAprovacaoDeCertificadoEstaVisivel"
        @close="fecharModalDeAprovacaoDeCertificado"
      >
        <form @submit.prevent="aprovarCertificado" class="formulario">
          <h3 class="titulo titulo_medio u-margem-inferior-media">
            Aprovar certificado
          </h3>
          <hr class="u-margem-inferior-grande" />
          <div>
            <p class="mensagem-confirmacao u-margem-inferior-grande">
              <strong>Tem certeza que deseja aprovar o certificado?</strong>
            </p>
          </div>
          <div
            class="grade__linha_alinhar-horizontal-direita formulario-button"
          >
            <button
              type="button"
              @click="fecharModalDeAprovacaoDeCertificado"
              class="botao botao_cinza botao_medio u-margem-direita-pequena"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="botao botao_cor-terciaria botao_medio"
              :class="{ 'is-loading': loading.visivel }"
            >
              Confirmar
            </button>
          </div>
        </form>
      </modal>
      <modal
        v-if="modalDeCancelamentoEstaVisivel"
        @close="fecharModalDeCancelamento"
      >
        <form @submit.prevent="cancelar" class="formulario">
          <h3 class="titulo titulo_medio u-margem-inferior-media">
            Cancelar solicitação
          </h3>
          <hr class="u-margem-inferior-media" />
          <label for="justificativa">Motivo do cancelamento</label>
          <textarea
            v-model="justificativa"
            name="justificativa"
            id="justificativa"
            cols="30"
            rows="8"
            class="input u-margem-inferior-media"
            placeholder="Descreva o motivo do cancelamento"
            required
          ></textarea>
          <div
            class="grade__linha_alinhar-horizontal-direita formulario-button"
          >
            <button
              type="button"
              @click="fecharModalDeCancelamento"
              class="botao botao_cinza botao_medio u-margem-direita-pequena"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="botao botao_cor-terciaria botao_medio"
              :disabled="!justificativa"
              :class="{ 'is-loading': loading.visivel }"
            >
              Confirmar
            </button>
          </div>
        </form>
      </modal>
      <MensagemFlutuante
        :mensagemVisivel="mensagemVisivel"
        :titulo="tituloMensagem"
        :estilo="estiloMensagem"
        :texto="textoMensagem"
        @close="fecharMensagem"
      />
    </div>
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";
import Download from "../../../utils/downloadDeArquivos.js";
import obterCorDoStatusDaSolicitacao from "../../../utils/statusDaSolicitacao";
import Loading from "../../shared/Loading";
import MensagemFlutuante from "../../shared/MensagemFlutuante";
import Modal from "../../shared/Modal";
import FiltrosDaTela, {
  TELA_LISTA_DE_SOLICITACOES,
} from "../../../utils/filtrosDaTela";

export default {
  name: "detalhes-da-solicitacao",
  components: { Loading, Modal, MensagemFlutuante },
  directives: { mask: AwesomeMask },
  filters: {
    upcase(data) {
      return data ? data.toUpperCase() : data;
    },
  },
  data() {
    return {
      proponentes: [],
      financiamento: {},
      imovel: {},
      rendaTotalComprovada: null,
      valorDaCompraEVenda: null,
      valorDoFinanciamentoAprovado: null,
      subsidioDaAgehab: null,
      subsidioDoGovernoFederal: null,
      participacaoDoSolicitante: null,
      descontoDaConstrutora: null,
      historicoDoStatus: null,
      loading: { visivel: true },
      status: null,
      statusDaSolicitacao: null,
      justificativa: "",
      dataDeEntregaDoCertificado: "",
      modalDeCancelamentoEstaVisivel: false,
      modalDeAprovacaoEstaVisivel: false,
      modalDeAprovacaoDeCertificadoEstaVisivel: false,
      modalDeEntregaDoCertificadoEstaVisivel: false,
      construtora: {},
      cidade: {},
      empreendimento: {},
      endereco: {
        Logradouro: null,
        NumeroDoImovel: null,
        Cep: null,
        Complemento: null,
        TipoDeLogradouro: {
          Nome: null,
        },
      },
      acoesPermidasDaSolicitacao: {
        PermiteImpressao: false,
        PermiteAprovacao: false,
        PermiteAprovacaoDeCertificado: false,
        PermiteCancelamento: false,
        PermiteDownloadDaDeclaracao: false,
        PermiteDownloadDoCertificado: false,
        PermiteEntregaDoCertificado: false,
        PermiteEdicao: false,
      },
      mensagemVisivel: false,
      textoMensagem: "",
      estiloMensagem: "",
      tituloMensagem: "",
    };
  },
  created() {
    this.carregarSolicitacao();
  },
  beforeDestroy() {
    if (window.location.href.indexOf("lista-de-solicitacoes") == -1) {
      FiltrosDaTela.remover(TELA_LISTA_DE_SOLICITACOES);
    }
  },
  methods: {
    formatarData(dataParaFormatar) {
      const date = new Date(dataParaFormatar).toISOString().split("T")[0];
      return date;
    },
    carregarSolicitacao() {
      this.loading.visivel = true;
      const idDaSolicitacao = this.$route.query.idDaSolicitacao;
      this.proponentes = [];

      this.$api
        .get(`/solicitacao/${idDaSolicitacao}`)
        .then((response) => {
          const solicitacao = response.data;
          this.proponentes = this.proponentes.concat(solicitacao.Proponentes);
          this.financiamento = solicitacao.Financiamento;
          this.imovel = solicitacao.Imovel;
          this.construtora = solicitacao.Imovel.Empreendimento.Construtora;
          this.cidade = solicitacao.Imovel.Endereco.Cidade;
          this.empreendimento = solicitacao.Imovel.Empreendimento;
          this.endereco = solicitacao.Imovel.Endereco;
          this.status = solicitacao.Status;
          this.statusDaSolicitacao = solicitacao.StatusDaSolicitacao;
          this.historicoDoStatus = solicitacao.HistoricoDoStatus;
          this.valorDaCompraEVenda = this.$moeda.formatar(
            this.financiamento.ValorDaCompraEVenda
          );
          this.valorDoFinanciamentoAprovado = this.$moeda.formatar(
            this.financiamento.ValorDoFinanciamentoAprovado
          );
          this.subsidioDaAgehab = this.$moeda.formatar(
            this.financiamento.SubsidioDaAgehab
          );
          this.subsidioDoGovernoFederal = this.$moeda.formatar(
            this.financiamento.SubsidioDoGovernoFederal
          );
          this.participacaoDoSolicitante = this.$moeda.formatar(
            this.financiamento.ParticipacaoDoSolicitante
          );
          this.descontoDaConstrutora = this.$moeda.formatar(
            this.financiamento.DescontoConstrutora
          );
          this.rendaTotalComprovada = this.$moeda.formatar(
            solicitacao.RendaTotalComprovada
          );
          this.endereco.Complemento = this.imovel.EhApartamento
            ? this.endereco.BlocoComApartamento
            : this.endereco.QuadraComLote;
          this.acoesPermidasDaSolicitacao = solicitacao.AcoesPermitidas;
          this.$forceUpdate();
        })
        .catch((error) => {
          this.tratarErro(error);
        })
        .finally(() => {
          this.esconderCarregamento();
        });
    },
    aprovar() {
      this.exibirCarregamento();
      const idDaSolicitacao = this.$route.query.idDaSolicitacao;
      this.$api
        .post(`/solicitacao/McmvCidades/${idDaSolicitacao}/Aprovar`)
        .then(() => {
          this.fecharModalDeAprovacao();
          this.carregarSolicitacao();
          this.exibirMensagemDeSucesso(
            "Status de aprovado alterado com sucesso!"
          );
        })
        .catch((error) => {
          this.tratarErro(error);
        })
        .finally(() => {
          this.fecharModalDeAprovacao();
          this.esconderCarregamento();
        });
    },
    aprovarCertificado() {
      this.exibirCarregamento();
      const idDaSolicitacao = this.$route.query.idDaSolicitacao;
      this.$api
        .post(`/solicitacao/McmvCidades/${idDaSolicitacao}/AprovarCertificado`)
        .then(() => {
          this.fecharModalDeAprovacaoDeCertificado();
          this.carregarSolicitacao();
          this.exibirMensagemDeSucesso("Certificado aprovado com sucesso!");
        })
        .catch((error) => {
          this.tratarErro(error);
        })
        .finally(() => {
          this.fecharModalDeAprovacaoDeCertificado();
          this.esconderCarregamento();
        });
    },
    permiteExibirJustificativaNoHistorico(historico) {
      return ["INDEFERIDO", "MINUTA REPROVADA"].includes(
        historico.DescricaoDoStatus
      );
    },
    cancelar() {
      const idDaSolicitacao = this.$route.query.idDaSolicitacao;
      let urlDeCancelamentoDeSolicitacao = `/solicitacao/McmvCidades/${idDaSolicitacao}/Cancelar`;
      this.exibirCarregamento(
        "Só um momento, estamos cancelando a solicitação"
      );
      this.$api
        .post(urlDeCancelamentoDeSolicitacao, {
          Justificativa: this.justificativa,
        })
        .then(() => {
          this.fecharModalDeCancelamento();
          this.carregarSolicitacao();
          this.exibirMensagemDeSucesso(
            "A solicitação foi cancelada com sucesso"
          );
        })
        .catch((error) => {
          this.tratarErro(error);
        })
        .finally(() => {
          this.fecharModalDeCancelamento();
          this.esconderCarregamento();
        });
    },
    baixarDeclaracao() {
      const idDaSolicitacao = this.$route.query.idDaSolicitacao;
      let download = new Download();
      const url = `/solicitacao/McmvCidades/${idDaSolicitacao}/BaixarDeclaracao`;
      const parametros = {
        solicitacaoId: idDaSolicitacao,
      };
      this.exibirCarregamento();
      download.realizarDownloadDeDocumentosComTratamentoDeErro(
        "GET",
        url,
        parametros,
        () => this.executarAcoesAposBaixarDeclaracao(),
        () => this.executarAcoesQuandoOcorrerErroAoBaixarDeclaracao()
      );
    },
    executarAcoesAposBaixarDeclaracao() {
      this.exibirMensagemDeSucesso("Declaração baixada com sucesso");
      this.esconderCarregamento();
    },
    executarAcoesQuandoOcorrerErroAoBaixarDeclaracao() {
      this.exibirMensagemDeErro(
        "Não foi possível obter a declaração, tente novamente ou contate o suporte"
      );
      this.esconderCarregamento();
    },
    baixarCertificado() {
      const idDaSolicitacao = this.$route.query.idDaSolicitacao;
      let download = new Download();
      const url = `/solicitacao/McmvCidades/${idDaSolicitacao}/BaixarCertificado`;
      this.exibirCarregamento();
      download.realizarDownloadDeDocumentosComTratamentoDeErro(
        "GET",
        url,
        {},
        () => this.executarAcoesAposBaixarCertificado(),
        () => this.executarAcoesQuandoOcorrerErroAoBaixarCertificado()
      );
    },
    executarAcoesAposBaixarCertificado() {
      this.exibirMensagemDeSucesso("Certificado baixado com sucesso!");
      this.esconderCarregamento();
    },
    executarAcoesQuandoOcorrerErroAoBaixarCertificado() {
      this.exibirMensagemDeErro(
        "Não foi possível baixar o certificado, tente novamente ou contate o suporte"
      );
      this.esconderCarregamento();
    },
    entregarCertificado() {
      const dataDeEntregaDoCertificadoFormatada = this.formatarData(
        this.dataDeEntregaDoCertificado
      );
      const idDaSolicitacao = this.$route.query.idDaSolicitacao;
      const url = `/solicitacao/McmvCidades/${idDaSolicitacao}/EntregarCertificado`;
      this.exibirCarregamento(
        "Só um momento, estamos registrando a informação de entrega do certificado"
      );
      this.$api
        .post(url, {
          DataDeEntregaDoCertificado: dataDeEntregaDoCertificadoFormatada,
        })
        .then(() => {
          this.fecharModalDeEntregaDoCertificado();
          this.carregarSolicitacao();
          this.exibirMensagemDeSucesso(
            "Data de entrega do certificado salva com sucesso!"
          );
        })
        .catch((error) => {
          this.tratarErro(error);
        })
        .finally(() => {
          this.fecharModalDeEntregaDoCertificado();
          this.esconderCarregamento();
        });
    },
    redirecionarParaEdicao() {
      const idDaSolicitacao = this.$route.query.idDaSolicitacao;
      this.$router.push({
        name: "EditarValoresDaSolicitacaoParaMcmvCidades",
        query: { idDaSolicitacao: idDaSolicitacao },
      });
    },
    abrirModalDeCancelamento() {
      this.modalDeCancelamentoEstaVisivel = true;
    },
    fecharModalDeCancelamento() {
      this.modalDeCancelamentoEstaVisivel = false;
    },
    abrirModalDeAprovacao() {
      this.modalDeAprovacaoEstaVisivel = true;
    },
    fecharModalDeAprovacao() {
      this.modalDeAprovacaoEstaVisivel = false;
    },
    abrirModalDeAprovacaoDeCertificado() {
      this.modalDeAprovacaoDeCertificadoEstaVisivel = true;
    },
    fecharModalDeAprovacaoDeCertificado() {
      this.modalDeAprovacaoDeCertificadoEstaVisivel = false;
    },
    abrirModalDeEntregaDoCertificado() {
      this.modalDeEntregaDoCertificadoEstaVisivel = true;
    },
    fecharModalDeEntregaDoCertificado() {
      this.modalDeEntregaDoCertificadoEstaVisivel = false;
    },
    tratarErro(error) {
      const mensagensDeErro = error.response.data.Message;
      let mensagem;

      if (mensagensDeErro) mensagem = mensagensDeErro.split(",").join("<br />");
      else
        mensagem =
          "Desculpe, ocorreu um erro interno. Tente novamente ou contate o suporte";

      this.exibirMensagemDeErro(mensagem);
    },
    exibirCarregamento(mensagem) {
      this.loading.visivel = true;
      this.loading.mensagem = mensagem;
    },
    esconderCarregamento() {
      this.loading.visivel = false;
      this.loading.mensagem = null;
    },
    classeCssDaCor(bloco, cor) {
      return cor ? `${bloco}_cor-${cor.toLowerCase()}` : "";
    },
    obterCorDoStatusDaSolicitacao,
    exibirMensagemDeSucesso(mensagem) {
      let estiloDaMensagem = "sucesso";
      let tituloDaMensagem = "Concluído";
      this.exibirMensagem(mensagem, estiloDaMensagem, tituloDaMensagem);
    },
    exibirMensagemDeErro(mensagem) {
      let estiloDaMensagem = "erro";
      this.exibirMensagem(mensagem, estiloDaMensagem);
    },
    exibirMensagem(mensagem, estiloDaMensagem, tituloDaMensagem) {
      this.mensagemVisivel = true;
      this.textoMensagem = mensagem;
      this.estiloMensagem = estiloDaMensagem;
      this.tituloMensagem = tituloDaMensagem || "";
      setTimeout(() => {
        this.fecharMensagem();
      }, 10000);
    },
    fecharMensagem() {
      this.mensagemVisivel = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// DetalhesDaSolicitacaoParaMcmvCidades.vue?b719fa50